import { type PushSubscription } from '@remix-pwa/push'
import { type IPushSubscription } from './push-subscription._._definitions'
import { type IUser } from './user._._definitions'

export enum NotificationType {
	TEST_NOTIFICATION = 'TEST_NOTIFICATION',
	NOTIFY = 'NOTIFY',
	NOTIFY_ALL = 'NOTIFY_ALL',
	REGISTER_DEVICE = 'REGISTER_DEVICE',
	UNREGISTER_DEVICE = 'UNREGISTER_DEVICE',
	UNREGISTER_ALL_DEVICES = 'UNREGISTER_ALL_DEVICES',
	VERIFY_REGISTRATION = 'verify-registration',
}

export const formatSubscriptionForPush = (
	subscription: Pick<IPushSubscription, 'endpoint' | 'p256dh' | 'auth'>,
): PushSubscription => {
	return {
		endpoint: subscription.endpoint,
		keys: {
			p256dh: subscription.p256dh,
			auth: subscription.auth,
		},
	}
}

export const formatSubscriptionsForPush = (
	subscriptions: Pick<IPushSubscription, 'endpoint' | 'p256dh' | 'auth'>[],
): PushSubscription[] => {
	return subscriptions.map(formatSubscriptionForPush)
}

export function userHasPushSubscriptions(user: IUser) {
	return (user.pushSubscriptions?.length ?? 0) > 0
}
